import { Component, type ErrorInfo, type ReactNode } from "react";

interface RouteDeliveryBoundaryProps {
  readonly children: ReactNode;
}

interface RouteDeliveryBoundaryState {
  readonly failed: boolean;
}

export class RouteDeliveryBoundary extends Component<
  RouteDeliveryBoundaryProps,
  RouteDeliveryBoundaryState
> {
  public override state: RouteDeliveryBoundaryState = { failed: false };

  public static getDerivedStateFromError(): RouteDeliveryBoundaryState {
    return { failed: true };
  }

  public override componentDidCatch(_error: Error, _info: ErrorInfo): void {
    // The recovery surface is intentionally local. Production telemetry is not
    // configured yet, and chunk details must not be presented as league state.
    void _error;
    void _info;
  }

  public override render(): ReactNode {
    if (this.state.failed) {
      return (
        <section className="route-delivery-error" role="alert">
          <p className="eyebrow">Command surface unavailable</p>
          <h1>This screen could not be opened.</h1>
          <p>
            League Command may be offline or a newer application version may be
            available. No official league action was submitted.
          </p>
          <div>
            <a className="lc-button lc-button--primary" href={window.location.href}>
              Retry this page
            </a>
            <a className="lc-button lc-button--secondary" href="/league">
              Return to Command Deck
            </a>
          </div>
        </section>
      );
    }

    return this.props.children;
  }
}
